export enum NavigationView {
    DASHBOARD = 'DASHBOARD',
    ESPACES = 'ESPACES',
    OUVRAGES = 'OUVRAGES',
    DOCUMENTS = 'DOCUMENTS',
    PERSONNES = 'PERSONNES'
}
